import * as React from 'react';

export enum ScoreType {
  Cancellation = 'cancellation',
  Timeliness = 'timeliness',
}

export interface IReliabilityScore {
  [key: string]: {
    count: number;
    score: number;
    target: number;
    details: {
      [key: string]: number;
    }
  }
}

interface TimelinessDetailsProps {
  reliabilityScore: IReliabilityScore;
  isOpen: boolean;
  onClose: () => void;
  providerId: number;
}

export class TimelinessDetails extends React.Component<TimelinessDetailsProps, any> {}